import React from 'react';
import { Tabs } from 'antd';
import ResourceStatistics from '../components/bussinessStatistics/resourceStatistics';
import OtherStatistics from '../components/bussinessStatistics/otherStatitics';
import StoryStatistics from '../components/bussinessStatistics/storyStatistics';
import './bussinessStatistics.scss'


const tabs = [
    {
        title: '稿件统计',
        key: '4'
    },
    {
        title: '资源统计',
        key: '1'
    },
    {
        title: '部门业务统计',
        key: '2'
    },
    {
        title: '记者业务统计',
        key: '3'
    },
   /* {
        title: '个人业务统计',
        key: '5'
    },*/
    {
        title: '选题统计',
        key: '6'
    },
    {
        title: '编辑业务统计',
        key: '7'
    }
]
const { TabPane } = Tabs;
class BussinessStatistics extends React.Component{
    constructor(props){
        super(props);
        this.state={
            activeKey:'4',
        }
    }

    renderContent = () => {
        const {activeKey } = this.state;
        switch(activeKey){
            case '4' : return <StoryStatistics />
            case '1' : return <ResourceStatistics />
            case '2' : return <OtherStatistics type="dept"/>
            case '3' : return <OtherStatistics type="reporter"/>
            // case '5' : return <OtherStatistics type="person" />
            case '6' : return <OtherStatistics type="topic" />
            case '7' : return <OtherStatistics type="edit" />
            default  : break
        }
    }

    changeTab = (key) =>{
        this.setState({
            activeKey : key
        })
    }

    render(){
        let height = window.innerHeight - 90
        return(
            <div className="bussiness-statistics" style={{ height }}>
                <div className="bussiness-statistics-title">
                    统计信息
                </div>
                <div className="bussiness-statistics-tabs">
                    <Tabs activeKey={this.state.activeKey} onChange={(key) => this.changeTab(key)}>
                        {
                            tabs.length > 0 && tabs.map((item) => (
                                <TabPane tab={item.title} key={item.key}></TabPane>
                            ))
                        }
                    </Tabs>
                </div>
                {
                    this.renderContent()
                }
            </div>
        )
    }
}

export default BussinessStatistics